import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import service from "../../../shared/core/services/user-profile-service";
import { HttpError } from "../../../shared/core/models";
import { cloneDeep, get, keys } from "lodash";
import { logger } from "../../../shared/core";
const initialState = {
  data: {},
  isLoading: false
};

/**
 * Thunks Actions
 */

const loadProfileWebContent = createAsyncThunk<any, any, any>(
  "profileweb/get",
  async (params: any, thunkAPI) => {
    const result: any = await service.getProfileContent();
    if (result.status === 400) {
      return thunkAPI.rejectWithValue((await result.json()) as HttpError);
    }

    const response = await result.json();
    thunkAPI.dispatch(onWebContentLoad(get(response, "body", {})));
    return response;
  }
);

const postProfileWebContent = createAsyncThunk<any, any, any>(
  "profileweb/post",
  async (params: any, thunkAPI) => {
    thunkAPI.dispatch(starLoading(params));
    const result: any = await service.postProfileContent(params);
    if (result.status === 400) {
      return thunkAPI.rejectWithValue((await result.json()) as HttpError);
    }

    const response = await result.json();
    thunkAPI.dispatch(onWebContentUpdate(get(response, "body", {})));
    thunkAPI.dispatch(endLoading());

    return response;
  }
);

/**
 * Reducers
 */
const profileWebReducer = createSlice({
  name: "profileweb",
  initialState: initialState,
  reducers: {
    onWebContentLoad(state, response) {
      state.data = response.payload;
    },
    onWebContentUpdate(state, response) {
      state.data = { ...state.data, ...response.payload };
    },
    onDeltaUpdate(state, response: any) {
      logger.log("running delta update");
      const payload = response.payload;
      const fieldValue = state.data[payload.field] || [];
      const newState = {};
      if (payload.index >= 0) {
        const deltaValueUpdated = fieldValue.map((item: any, index: number) => {
          const obj = { ...item };
          if (index === payload.index) {
            obj[payload.key] = payload.value;
          }
          return obj;
        });
        newState[payload.field] = deltaValueUpdated;
      } else {
        fieldValue.push(payload.value);
        newState[payload.field] = cloneDeep(fieldValue);
      }

      state.data = { ...state.data, ...newState };
    },
    onUpdate(state, response: any) {
      const payload = response.payload;
      const fieldValue = state.data[payload.field];
      const newState = {};
      newState[payload.field] = fieldValue;
      state.data = { ...state.data, ...newState };
    },
    starLoading(state) {
      state.isLoading = true;
    },
    endLoading(state) {
      state.isLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(
      postProfileWebContent.pending,
      (state, {}: PayloadAction<any, any>) => {
        state.isLoading = true;
      }
    );
    builder.addCase(
      loadProfileWebContent.pending,
      (state, {}: PayloadAction<any>) => {
        state.isLoading = true;
      }
    );
    builder.addCase(
      postProfileWebContent.fulfilled,
      (state, {}: PayloadAction<any>) => {
        state.isLoading = false;
      }
    );
    builder.addCase(
      loadProfileWebContent.fulfilled,
      (state, {}: PayloadAction<any>) => {
        state.isLoading = false;
      }
    );
    builder.addCase(
      loadProfileWebContent.rejected || postProfileWebContent.rejected,
      (state: any, action) => {
        state.isLoading = false;
        state.updatingKeys=[]
        if (action.payload) {
          // Since we passed in `MyKnownError` to `rejectType` in `updateUser`, the type information will be available here.
          state.error = action.error;
        }
      }
    );
  },
});

/*Actions export*/
const {
  starLoading,
  endLoading,
  onWebContentLoad,
  onWebContentUpdate,
  onDeltaUpdate,
} = profileWebReducer.actions;

export {
  starLoading,
  endLoading,
  onWebContentLoad,
  onWebContentUpdate,
  loadProfileWebContent,
  postProfileWebContent,
  onDeltaUpdate,
};
/*Reducer export*/
export default profileWebReducer;
